
export const tutorials = {
  'backoffice.sidebarUser.sections.tutorials.items.theClubRegistration': 'The Club Kayıt',

  // Tutorials Index Page
  'tutorials.index.title': 'Öğrenme Merkezi',
  'tutorials.index.subtitle': 'Başlamanıza yardımcı olacak adım adım kılavuzlar',

  // Common
  'tutorials.common.downloadPdf': 'PDF Kılavuzu İndir',
  'tutorials.common.pdfAlternative': 'Kapsamlı PDF kılavuzumuzu indirin',
  'tutorials.common.watchVideo': 'Eğitim Videosunu İzle',
  'tutorials.common.pdfName': 'TheClub_Registration_Guide_EN.pdf',

  // Tutorial: Radex Markets Registration
  'tutorials.radexRegistration.title': 'Radex Markets Broker\'da Kayıt',
  'tutorials.radexRegistration.description': 'TheClub\'ın düzenlenmiş broker ortağı Radex Markets\'ta hesabınızı nasıl açacağınızı ve kuracağınızı öğrenin. Bu kılavuz hesap oluşturma, belge gönderme ve kimlik doğrulamayı kapsar.',
  'tutorials.radexRegistration.links.registration': 'Radex Markets Kayıt',

  // Tutorial: Wire Transfer
  'tutorials.wireTransfer.title': 'Banka Havalesi ile Hesap Fonlama',
  'tutorials.wireTransfer.description': 'Banka havalesi kullanarak Radex Markets hesabınıza nasıl para yatıracağınıza dair eksiksiz bir kılavuz. Banka bilgileri, işlem süreleri ve onay adımlarını kapsar.',
  'tutorials.wireTransfer.links.login': 'Radex Markets Giriş',

  // Tutorial: Card Funding
  'tutorials.cardFunding.title': 'Kredi/Banka Kartı ile Hesap Fonlama',
  'tutorials.cardFunding.description': 'Visa veya Mastercard kredi veya banka kartı kullanarak Radex Markets hesabınıza nasıl para yatıracağınıza dair eksiksiz bir kılavuz. Hızlı, güvenli ve dakikalar içinde hazır.',
  'tutorials.cardFunding.links.login': 'Radex Markets Giriş',

  // Tutorial: PAMM Registration
  'tutorials.pammRegistration.title': 'TheClub PAMM Hesabına Kayıt',
  'tutorials.pammRegistration.description': 'Fonlarınızın profesyonel yatırımcılarımız tarafından yönetilmesi için Radex Markets hesabınızı TheClub\'ın PAMM sistemine nasıl bağlayacağınızı öğrenin.',
  'tutorials.pammRegistration.links.institutional': 'Kurumsal Trading PAMM Hesabı',
  'tutorials.pammRegistration.links.spartan': 'Spartan AI Trading PAMM Hesabı',
  'tutorials.pammRegistration.links.login': 'PAMM Hesap Giriş',

  // Tutorial: TheClub Account Creation
  'tutorials.theclubAccount.title': 'TheClub Hesabı Oluşturma',
  'tutorials.theclubAccount.description': 'Platformda kaydolmaktan PAMM hesap ilişkilendirmesini tamamlamaya kadar TheClub üyelik hesabınızı oluşturmak için adım adım talimatlar.',
  'tutorials.theclubAccount.links.registration': 'TheClub Kayıt Sayfası',
  'tutorials.theclubAccount.links.registrationNote': 'Sponsorunuz tarafından sağlanan bağlantıyı kullanın',
  'tutorials.theclubAccount.links.website': 'TheClub Web Sitesi',
};
